"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveScanCenterCodeEnum = exports.ScanCenterCodeEnum = void 0;
const data_types_1 = require("@getcaya/data-types");
Object.defineProperty(exports, "ScanCenterCodeEnum", { enumerable: true, get: function () { return data_types_1.ScanCenterCodeEnum; } });
exports.ActiveScanCenterCodeEnum = {
    ODS: data_types_1.ScanCenterCodeEnum.ODS,
    SPS: data_types_1.ScanCenterCodeEnum.SPS,
    SRZ: data_types_1.ScanCenterCodeEnum.SRZ,
};
//# sourceMappingURL=interfaces.js.map